<template>
  <div>
    <v-card flat rounded="lg">
      <v-card-title class="font-weight-bold subtitle-1"
        >Dados complementares</v-card-title
      >
      <v-card-text>
        <v-textarea
          rows="4"
          label="Observações"
          v-model="obsModel"
        ></v-textarea>
      </v-card-text>
    </v-card>

    <assinatura-pedido :assinatura_obrigatoria="config.assinatura_obrigatoria" class="mt-3" />
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
import AssinaturaPedido from "../../novo-pedido/AssinaturaPedido.vue";
export default {
  components: {
    AssinaturaPedido,
  },
  computed: {
    ...mapState("insumos", ["observacao", "config"]),
    obsModel: {
      get: function () {
        return this.observacao;
      },
      set: function (value) {
        this.setObservacao(value);
      },
    },
  },
  methods: {
    ...mapMutations("insumos", ["setObservacao"]),
  },
};
</script>

<style>
</style>